import React from 'react';

import '../../assets/styles/AppealsWidget.css';
import { submitAppeal } from '../../api/appeals';
import { APPEALS_WIDGET_OPEN_EVENT } from '../../constants/appealsWidget';
import { useLanguage } from '../../context/LanguageContext';

const widgetTexts = {
  uz: {
    fab: 'Chat',
    open: "Murojaatlar chatini ochish",
    close: 'Yopish',
    chooseDirection: "Yo'nalishni tanlang",
    intro: "Kerakli bo'limni tanlang va murojaatingizni tez yuboring.",
    changeDirection: "O'zgartirish",
    fullNameLabel: 'Ismi va familiyasi',
    phoneLabel: 'Telefon raqami',
    telegramLabel: 'Telegram niki',
    messageLabel: 'Murojaat matni',
    contactHint: "Telefon yoki Telegram nikidan bittasi majburiy.",
    submit: 'Yuborish',
    sending: 'Yuborilmoqda...',
    success: "Murojaatingiz qabul qilindi. Tez orada siz bilan bog'lanishadi.",
    fullNameRequired: 'Ism va familiyani kiriting.',
    messageRequired: 'Murojaat matnini kiriting.',
    contactRequired: "Telefon yoki Telegram nikini kiriting.",
    categories: {
      admission: "Qabul bo'yicha murojaat",
      academic: "O'quv bo'limiga murojaat",
      students: "Talabalar bo'limiga murojaat",
      accounting: "Buxgalteriya bo'limiga murojaat",
      other: "Boshqa murojaatlar"
    },
    badges: {
      admission: 'Qabul',
      academic: "O'quv",
      students: 'Talabalar',
      accounting: 'Hisob',
      other: 'Boshqa'
    }
  },
  ru: {
    fab: 'Чат',
    open: 'Открыть чат обращений',
    close: 'Закрыть',
    chooseDirection: 'Выберите направление',
    intro: 'Выберите нужный отдел и быстро отправьте обращение.',
    changeDirection: 'Изменить',
    fullNameLabel: 'Имя и фамилия',
    phoneLabel: 'Телефон',
    telegramLabel: 'Telegram ник',
    messageLabel: 'Текст обращения',
    contactHint: 'Телефон или Telegram ник обязателен.',
    submit: 'Отправить',
    sending: 'Отправляется...',
    success: 'Ваше обращение принято. С вами скоро свяжутся.',
    fullNameRequired: 'Введите имя и фамилию.',
    messageRequired: 'Введите текст обращения.',
    contactRequired: 'Укажите телефон или Telegram ник.',
    categories: {
      admission: 'Обращение по приёму',
      academic: 'Обращение в учебный отдел',
      students: 'Обращение в студенческий отдел',
      accounting: 'Обращение в бухгалтерию',
      other: 'Другие обращения'
    },
    badges: {
      admission: 'Приём',
      academic: 'Учёба',
      students: 'Студенты',
      accounting: 'Бухг.',
      other: 'Другое'
    }
  },
  en: {
    fab: 'Chat',
    open: 'Open appeals chat',
    close: 'Close',
    chooseDirection: 'Choose a department',
    intro: 'Select the right office and send your request quickly.',
    changeDirection: 'Change',
    fullNameLabel: 'Full name',
    phoneLabel: 'Phone number',
    telegramLabel: 'Telegram username',
    messageLabel: 'Your message',
    contactHint: 'Phone or Telegram username is required.',
    submit: 'Send',
    sending: 'Sending...',
    success: 'Your request has been received. You will be contacted soon.',
    fullNameRequired: 'Please enter your full name.',
    messageRequired: 'Please enter your message.',
    contactRequired: 'Please enter phone or Telegram username.',
    categories: {
      admission: 'Admission request',
      academic: 'Academic office request',
      students: 'Student office request',
      accounting: 'Accounting office request',
      other: 'Other requests'
    },
    badges: {
      admission: 'Adm',
      academic: 'Acad',
      students: 'Stud',
      accounting: 'Acc',
      other: 'Other'
    }
  },
  ko: {
    fab: '채팅',
    open: '문의 채팅 열기',
    close: '닫기',
    chooseDirection: '부서를 선택하세요',
    intro: '원하는 부서를 선택하고 문의를 빠르게 보내세요.',
    changeDirection: '변경',
    fullNameLabel: '이름과 성',
    phoneLabel: '전화번호',
    telegramLabel: '텔레그램 아이디',
    messageLabel: '문의 내용',
    contactHint: '전화번호 또는 텔레그램 아이디 중 하나는 필수입니다.',
    submit: '보내기',
    sending: '전송 중...',
    success: '문의가 접수되었습니다. 곧 연락드리겠습니다.',
    fullNameRequired: '이름과 성을 입력하세요.',
    messageRequired: '문의 내용을 입력하세요.',
    contactRequired: '전화번호 또는 텔레그램 아이디를 입력하세요.',
    categories: {
      admission: '입학 문의',
      academic: '학사팀 문의',
      students: '학생팀 문의',
      accounting: '회계팀 문의',
      other: '기타 문의'
    },
    badges: {
      admission: '입학',
      academic: '학사',
      students: '학생',
      accounting: '회계',
      other: '기타'
    }
  }
};

const defaultForm = {
  fullName: '',
  phone: '',
  telegramUsername: '',
  message: ''
};

function SupportBeaconIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M15 3.75V7.5" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
      <circle cx="15" cy="3.2" r="1.8" fill="currentColor" />
      <path
        d="M10.75 8.75H19.25C22.7018 8.75 25.5 11.5482 25.5 15V15.75C25.5 19.2018 22.7018 22 19.25 22H17.25L13.2 25.2C12.6221 25.6567 11.75 25.245 11.75 24.5085V22H10.75C7.29822 22 4.5 19.2018 4.5 15.75V15C4.5 11.5482 7.29822 8.75 10.75 8.75Z"
        stroke="currentColor"
        strokeWidth="1.9"
      />
      <rect
        x="10.1"
        y="12.2"
        width="9.8"
        height="6.8"
        rx="3.1"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <circle cx="13.2" cy="15.6" r="1.15" fill="currentColor" />
      <circle cx="16.8" cy="15.6" r="1.15" fill="currentColor" />
      <path
        d="M13 18.2C13.6 18.65 14.2 18.85 15 18.85C15.8 18.85 16.4 18.65 17 18.2"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path d="M9.2 11.75L7.7 10.45" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M20.8 11.75L22.3 10.45" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  );
}

function DepartmentGlyph({ type }) {
  if (type === 'admission') {
    return (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="7" y="6.75" width="12" height="12.5" rx="2.6" stroke="currentColor" strokeWidth="1.8" />
        <path d="M9.75 10H16.25" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M9.75 13H14.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M9.75 16H13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }

  if (type === 'academic') {
    return (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M7.25 7.25H18.75C19.4404 7.25 20 7.80964 20 8.5V18.5C20 19.1904 19.4404 19.75 18.75 19.75H7.25V7.25Z" stroke="currentColor" strokeWidth="1.8" />
        <path d="M7.25 9C6.14543 9 5.25 9.89543 5.25 11V17C5.25 18.1046 6.14543 19 7.25 19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M9.75 11H16.75" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M9.75 14H15.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }

  if (type === 'students') {
    return (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M13 6L20.5 9.75L13 13.5L5.5 9.75L13 6Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M8.25 12V15.25C8.25 16.9069 10.3766 18.25 13 18.25C15.6234 18.25 17.75 16.9069 17.75 15.25V12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M20.5 10V15.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }

  if (type === 'accounting') {
    return (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="7" y="5.75" width="12" height="14.5" rx="2.7" stroke="currentColor" strokeWidth="1.8" />
        <path d="M9.75 9.25H16.25" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M10.25 13H10.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M13 13H13.25" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M15.75 13H16" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M10.25 16H10.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M13 16H16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M7.25 8.25H18.75C19.9926 8.25 21 9.25736 21 10.5V15C21 16.2426 19.9926 17.25 18.75 17.25H14.2L10.5 20.1V17.25H7.25C6.00736 17.25 5 16.2426 5 15V10.5C5 9.25736 6.00736 8.25 7.25 8.25Z" stroke="currentColor" strokeWidth="1.8" />
      <path d="M10 12.75H10.2" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      <path d="M13 12.75H13.2" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      <path d="M16 12.75H16.2" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}

function getWidgetTexts(languageCode) {
  return widgetTexts[languageCode] || widgetTexts.uz;
}

export default function AppealsWidget() {
  const { currentLanguageCode } = useLanguage();
  const texts = React.useMemo(
    () => getWidgetTexts(currentLanguageCode),
    [currentLanguageCode]
  );

  const categories = React.useMemo(
    () => [
      {
        key: 'admission',
        title: texts.categories.admission,
        badge: texts.badges.admission,
        orbitX: '0px',
        orbitY: '-88px',
        orbitMobileX: '0px',
        orbitMobileY: '-82px',
        orbitDelay: '0ms',
        labelDelay: '180ms'
      },
      {
        key: 'academic',
        title: texts.categories.academic,
        badge: texts.badges.academic,
        orbitX: '0px',
        orbitY: '-160px',
        orbitMobileX: '0px',
        orbitMobileY: '-148px',
        orbitDelay: '70ms',
        labelDelay: '250ms'
      },
      {
        key: 'students',
        title: texts.categories.students,
        badge: texts.badges.students,
        orbitX: '0px',
        orbitY: '-232px',
        orbitMobileX: '0px',
        orbitMobileY: '-214px',
        orbitDelay: '140ms',
        labelDelay: '320ms'
      },
      {
        key: 'accounting',
        title: texts.categories.accounting,
        badge: texts.badges.accounting,
        orbitX: '0px',
        orbitY: '-304px',
        orbitMobileX: '0px',
        orbitMobileY: '-280px',
        orbitDelay: '210ms',
        labelDelay: '390ms'
      },
      {
        key: 'other',
        title: texts.categories.other,
        badge: texts.badges.other,
        orbitX: '0px',
        orbitY: '-376px',
        orbitMobileX: '0px',
        orbitMobileY: '-346px',
        orbitDelay: '280ms',
        labelDelay: '460ms'
      }
    ],
    [texts]
  );

  const [isOpen, setIsOpen] = React.useState(false);
  const [selectedCategoryKey, setSelectedCategoryKey] = React.useState('');
  const [form, setForm] = React.useState(defaultForm);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [successMessage, setSuccessMessage] = React.useState('');
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const selectedCategory =
    categories.find((category) => category.key === selectedCategoryKey) || null;

  React.useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
        setSelectedCategoryKey('');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  React.useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const handleExternalOpen = () => {
      setIsOpen(true);
      setSelectedCategoryKey('');
      setErrorMessage('');
      setSuccessMessage('');
    };

    window.addEventListener(APPEALS_WIDGET_OPEN_EVENT, handleExternalOpen);

    return () => {
      window.removeEventListener(APPEALS_WIDGET_OPEN_EVENT, handleExternalOpen);
    };
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((currentForm) => ({
      ...currentForm,
      [name]: value
    }));
  };

  const handleClose = () => {
    setIsOpen(false);
    setSelectedCategoryKey('');
    setErrorMessage('');
    setSuccessMessage('');
  };

  const handleSelectCategory = (categoryKey) => {
    setIsOpen(true);
    setSelectedCategoryKey(categoryKey);
    setErrorMessage('');
    setSuccessMessage('');
  };

  const validateForm = () => {
    if (!form.fullName.trim()) {
      return texts.fullNameRequired;
    }

    if (!form.message.trim()) {
      return texts.messageRequired;
    }

    if (!form.phone.trim() && !form.telegramUsername.trim()) {
      return texts.contactRequired;
    }

    return '';
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const validationError = validateForm();

    if (validationError) {
      setErrorMessage(validationError);
      setSuccessMessage('');
      return;
    }

    if (!selectedCategoryKey) {
      return;
    }

    setIsSubmitting(true);
    setErrorMessage('');
    setSuccessMessage('');

    try {
      await submitAppeal({
        departmentKey: selectedCategoryKey,
        fullName: form.fullName.trim(),
        phone: form.phone.trim(),
        telegramUsername: form.telegramUsername.trim(),
        message: form.message.trim()
      });

      setForm(defaultForm);
      setSuccessMessage(texts.success);
    } catch (error) {
      setErrorMessage(error.message || "Murojaatni yuborib bo'lmadi.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={`appeals-widget-root ${isOpen ? 'is-open' : ''}`}>
      {isOpen ? (
        <button
          type="button"
          className="appeals-widget-overlay"
          aria-label={texts.close}
          onClick={handleClose}
        />
      ) : null}

      <div className="appeals-widget-anchor">
        <div
          className={`appeals-widget-orbit ${isOpen && !selectedCategory ? 'is-visible' : ''}`}
          aria-hidden={!isOpen || Boolean(selectedCategory)}
        >
          {categories.map((category, index) => (
            <button
              key={category.key}
              type="button"
              className="appeals-widget-orbit-item"
              style={{
                '--orbit-x': category.orbitX,
                '--orbit-y': category.orbitY,
                '--orbit-mobile-x': category.orbitMobileX,
                '--orbit-mobile-y': category.orbitMobileY,
                '--orbit-delay': category.orbitDelay || `${index * 35}ms`,
                '--orbit-label-delay': category.labelDelay || `${index * 35 + 180}ms`
              }}
              onClick={() => handleSelectCategory(category.key)}
              tabIndex={isOpen && !selectedCategory ? 0 : -1}
            >
              <span className="appeals-widget-orbit-item__content">
                <span className="appeals-widget-orbit-item__eyebrow">{category.badge}</span>
                <span className="appeals-widget-orbit-item__title">{category.title}</span>
              </span>
              <span className="appeals-widget-orbit-item__arrow">→</span>
              <span className="appeals-widget-orbit-item__badge">
                <DepartmentGlyph type={category.key} />
              </span>
            </button>
          ))}
        </div>

        <button
          type="button"
          className="appeals-widget-fab"
          aria-label={isOpen ? texts.close : texts.open}
          onClick={() => {
            if (isOpen) {
              handleClose();
              return;
            }

            setIsOpen(true);
          }}
        >
          <span className="appeals-widget-fab__icon">
            <SupportBeaconIcon />
          </span>
          <span className="appeals-widget-fab__text">{texts.fab}</span>
        </button>
      </div>

      <aside
        className={`appeals-widget-panel ${
          isOpen && selectedCategory ? 'is-visible' : ''
        }`}
        aria-hidden={!isOpen || !selectedCategory}
      >
        <div className="appeals-widget-panel__header">
          <button
            type="button"
            className="appeals-widget-panel__close"
            aria-label={texts.close}
            onClick={handleClose}
          >
            ×
          </button>
        </div>

        {selectedCategory ? (
          <form className="appeals-widget-form" onSubmit={handleSubmit}>
            <div className="appeals-widget-form__section appeals-widget-form__section--direction">
              <div className="appeals-widget-panel__direction">
                <div className="appeals-widget-panel__selected">
                  <span className="appeals-widget-panel__selected-badge">
                    <DepartmentGlyph type={selectedCategory.key} />
                  </span>
                  <span className="appeals-widget-panel__selected-copy">
                    <strong>{selectedCategory.title}</strong>
                  </span>
                </div>

                <button
                  type="button"
                  className="appeals-widget-panel__back"
                  onClick={() => {
                    setSelectedCategoryKey('');
                    setErrorMessage('');
                    setSuccessMessage('');
                  }}
                >
                  {texts.changeDirection}
                </button>
              </div>
            </div>

            <div className="appeals-widget-form__section">
              <label className="appeals-widget-field">
                <span>{texts.fullNameLabel}</span>
                <input
                  name="fullName"
                  type="text"
                  value={form.fullName}
                  onChange={handleChange}
                  autoComplete="name"
                  placeholder={texts.fullNameLabel}
                />
              </label>

              <div className="appeals-widget-field-grid">
                <label className="appeals-widget-field">
                  <span>{texts.phoneLabel}</span>
                  <input
                    name="phone"
                    type="text"
                    value={form.phone}
                    onChange={handleChange}
                    autoComplete="tel"
                    placeholder="+998 90 123 45 67"
                  />
                </label>

                <label className="appeals-widget-field">
                  <span>{texts.telegramLabel}</span>
                  <input
                    name="telegramUsername"
                    type="text"
                    value={form.telegramUsername}
                    onChange={handleChange}
                    placeholder="@username"
                  />
                </label>
              </div>
            </div>

            <div className="appeals-widget-form__section">
              <label className="appeals-widget-field">
                <span>{texts.messageLabel}</span>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  rows="5"
                  placeholder={texts.messageLabel}
                />
              </label>
            </div>

            <div className="appeals-widget-form__footer">
              {errorMessage ? (
                <div className="appeals-widget-alert is-error">{errorMessage}</div>
              ) : null}

              {successMessage ? (
                <div className="appeals-widget-alert is-success">{successMessage}</div>
              ) : null}

              <button type="submit" className="appeals-widget-submit" disabled={isSubmitting}>
                {isSubmitting ? texts.sending : texts.submit}
              </button>
            </div>
          </form>
        ) : null}
      </aside>
    </div>
  );
}
